export default __webpack_public_path__ + "static/HA-PNGLogoFinal(SRK)-dc31b21c6b43614d5d016789c7b23360.png";